export const createAccountGroupMaster = /* GraphQL */ `
  mutation CreateAccountGroupMaster(
    $createAccountGroupMasterInput: CreateAccountGroupMasterInput!
  ) {
    createAccountGroupMaster(
      createAccountGroupMasterInput: $createAccountGroupMasterInput
    ) {
      accountgroupid
      companyid
      companybranchid
      enteredtimestamp
      expiredtimestamp
      accounttypecd
      accountgroupname
      accountparentgroupid
      displayordernumber
      statuscode
      statusmessage
      restrictedflag
      is_active
      __typename
    }
  }
`;

export const createBankDetailsCustom = /* GraphQL */ `
  mutation CreateBankDetails(
    $createBankDetailsInput: [CreateBankDetailsInput!]!
  ) {
    createBankDetails(createBankDetailsInput: $createBankDetailsInput) {
      bankdetailsid
      relatedaccountdetails {
        accountsid 
      }
    }
  }
`;
export const createItemMasterWithDetailsAndImages = /* GraphQL */ `
  mutation CreateItemMasterWithDetailsAndImages(
    $createItemMasterInput: CreateItemMasterInput!
    $createItemAmountDetailsInput: [CreateItemAmountDetailsInput!]!
    $createItemImagesInput: [CreateItemImagesInput!]!
  ) {
    createItemMaster(createItemMasterInput: $createItemMasterInput) {
      itemid
      itemcode
      companyid
      enteredtimestamp
      expiredtimestamp
      itemname
      salesinvoiceflag
      purchaseinvoiceflag
      itemcategorycd
      measurementcd
      currencycd
      salesaccountid
      purchaseaccountid
      taxabilitycd
      reversechargeflag
      itemtype
      hsnid
      is_active
      statuscode
      statusmessage
      relateditemamountdetails {
        itemid
        companyid
        companybranchid
        enteredtimestamp
        expiredtimestamp
        amount
        effectivedate
        expireddate
        hsnid
        gstcompensationtype
        gstcompensationvalue
        gstrate
        statuscode
        statusmessage
        lastupdatedby
        discounttype
        discountvalue
        invoicetype
        pricetype
        isactive
        isdefault
        __typename
      }
      relateditemgstdetails {
        itemid
        companyid
        enteredtimestamp
        expiredtimestamp
        hsnid
        gstcesstype
        gstcompensationvalue
        effectivedate
        expireddate
        gstcessvalue
        lastupdatedby
        statuscode
        statusmessage
        __typename
      }
      relateditemimages {
        attachmentid
        itemid
        companyid
        companybranchid
        enteredtimestamp
        expiredtimestamp
        imagename
        imageurl
        documentname
        type
        lastupdatedby
        statuscode
        statusmessage
        __typename
      }
      lastupdatedby
      serialnumber
      financialyearid
      description
      hsnsacid
      hsncodetype
      hsncodevalue
      hsndescription
      __typename
    }
    createItemAmountDetails(createItemAmountDetailsInput: $createItemAmountDetailsInput) {
      itemid
      companyid
      companybranchid
      enteredtimestamp
      expiredtimestamp
      amount
      effectivedate
      expireddate
      hsnid
      gstcompensationtype
      gstcompensationvalue
      gstrate
      statuscode
      statusmessage
      lastupdatedby
      discounttype
      discountvalue
      invoicetype
      pricetype
      isactive
      isdefault
      __typename
    }
    createItemImages(createItemImagesInput: $createItemImagesInput) {
      attachmentid
      itemid
      companyid
      companybranchid
      enteredtimestamp
      expiredtimestamp
      imagename
      imageurl
      documentname
      type
      lastupdatedby
      statuscode
      statusmessage
      __typename
    }
  }
`;
export const createItemMasterWithDetails = /* GraphQL */ `
  mutation CreateItemMasterWithDetailsAndImages(
    $createItemMasterInput: CreateItemMasterInput!
    $createItemAmountDetailsInput: [CreateItemAmountDetailsInput!]!
  ) {
    createItemMaster(createItemMasterInput: $createItemMasterInput) {
      itemid
      itemcode
      companyid
      enteredtimestamp
      expiredtimestamp
      itemname
      salesinvoiceflag
      purchaseinvoiceflag
      itemcategorycd
      measurementcd
      currencycd
      salesaccountid
      purchaseaccountid
      taxabilitycd
      reversechargeflag
      itemtype
      hsnid
      is_active
      statuscode
      statusmessage
      relateditemamountdetails {
        itemid
        companyid
        companybranchid
        enteredtimestamp
        expiredtimestamp
        amount
        effectivedate
        expireddate
        hsnid
        gstcompensationtype
        gstcompensationvalue
        gstrate
        statuscode
        statusmessage
        lastupdatedby
        discounttype
        discountvalue
        invoicetype
        pricetype
        isactive
        isdefault
        __typename
      }
      relateditemgstdetails {
        itemid
        companyid
        enteredtimestamp
        expiredtimestamp
        hsnid
        gstcesstype
        gstcompensationvalue
        effectivedate
        expireddate
        gstcessvalue
        lastupdatedby
        statuscode
        statusmessage
        __typename
      }
      relateditemimages {
        attachmentid
        itemid
        companyid
        companybranchid
        enteredtimestamp
        expiredtimestamp
        imagename
        imageurl
        documentname
        type
        lastupdatedby
        statuscode
        statusmessage
        __typename
      }
      lastupdatedby
      serialnumber
      financialyearid
      description
      hsnsacid
      hsncodetype
      hsncodevalue
      hsndescription
      __typename
    }
    createItemAmountDetails(createItemAmountDetailsInput: $createItemAmountDetailsInput) {
      itemid
      companyid
      companybranchid
      enteredtimestamp
      expiredtimestamp
      amount
      effectivedate
      expireddate
      hsnid
      gstcompensationtype
      gstcompensationvalue
      gstrate
      statuscode
      statusmessage
      lastupdatedby
      discounttype
      discountvalue
      invoicetype
      pricetype
      isactive
      isdefault
      __typename
    }
    
  }
`;



//invoice Mutation
export const createInvoiceBatch = /* GraphQL */ `
  mutation CreateInvoiceBatch(
    $createInvoiceMasterInput: CreateInvoiceMasterInput!
    $createInvoiceAttachmentInput: [CreateInvoiceAttachmentInput!]!
    $createInvoiceDispatchInput: [CreateInvoiceDispatchInput!]!
    $createInvoiceLineGSTInput: [CreateInvoiceLineGSTInput!]!
    $createInvoiceLineItemsInput: [CreateInvoiceLineItemsInput!]!
    $createInvoiceLineNonGSTInput: [CreateInvoiceLineNonGSTInput!]!
    $createInvoiceLineNonItemsInput: [CreateInvoiceLineNonItemsInput!]!
    $createInvoiceTCSDetailsInput: [CreateInvoiceTCSDetailsInput!]!
    $createPartyAddressEntityInput: [CreatePartyAddressEntityInput!]!
    $createTransactionWithSpecificTimeInput: CreateTransactionWithSpecificTimeInput!
  ) {
    createInvoiceMaster(createInvoiceMasterInput: $createInvoiceMasterInput) {
      invoiceid
      companyid
      invoicenumber
      lastupdatedby
      statuscode
      statusmessage
      cancelflag
    }

    createInvoiceAttachment(createInvoiceAttachmentInput: $createInvoiceAttachmentInput) {
      invoiceid
      attachmentid
      companyid
      companybranchid
      enteredtimestamp
      expiredtimestamp
      attachmentname
      attachmenturl
      lastupdatedby
      statuscode
      statusmessage
      documentname
      type
      __typename
    }

    createInvoiceDispatch(createInvoiceDispatchInput: $createInvoiceDispatchInput) {
      invoiceid
      dispatchid
      companyid
      companybranchid
      enteredtimestamp
      expiredtimestamp
      transportationcd
      vehiclenumber
      dispatchdate
      ewaybillnumber
      lastupdatedby
      statuscode
      statusmessage
      __typename
    }

    createInvoiceLineGST(createInvoiceLineGSTInput: $createInvoiceLineGSTInput) {
      invoiceid
      invoiceitemid
      companyid
      companybranchid
      enteredtimestamp
      expiredtimestamp
      gstrate
      gsttypecd
      gstamount
      cessamount
      lastupdatedby
      statuscode
      statusmessage
      __typename
    }

    createInvoiceLineItems(createInvoiceLineItemsInput: $createInvoiceLineItemsInput) {
      invoiceid
      invoiceitemid
      companyid
      companybranchid
      enteredtimestamp
      expiredtimestamp
      lineitemnumber
      invoicelineitemtype
      itemid
      quantity
      unittypecd
      itemrate
      itemamount
      itemdiscount
      netamount
      hsnsaccode
      taxability
      itemname
      relatedinvoicelinegst {
        invoiceid
        invoiceitemid
        companyid
        companybranchid
        enteredtimestamp
        expiredtimestamp
        gstrate
        gsttypecd
        gstamount
        cessamount
        lastupdatedby
        statuscode
        statusmessage
        __typename
      }
      relateditemmaster {
        itemid
        itemcode
        companyid
        enteredtimestamp
        expiredtimestamp
        itemname
        salesinvoiceflag
        purchaseinvoiceflag
        itemcategorycd
        measurementcd
        currencycd
        salesaccountid
        purchaseaccountid
        taxabilitycd
        reversechargeflag
        itemtype
        hsnid
        is_active
        statuscode
        statusmessage
        relateditemamountdetails {
          id
          itemid
          companyid
          companybranchid
          enteredtimestamp
          expiredtimestamp
          amount
          effectivedate
          expireddate
          hsnid
          gstcompensationtype
          gstcompensationvalue
          gstrate
          statuscode
          statusmessage
          lastupdatedby
          discounttype
          discountvalue
          invoicetype
          pricetype
          pricetypeid
          isactive
          isdefault
          __typename
        }
      }
      lastupdatedby
      statuscode
      statusmessage
      pricetype
      lotid
      hsnsacid
      hsncodetype
      hsncodevalue
      hsndescription
      gstrate
      gsttypecd
      gstamount
      cessamount
      unit
      uqc
      salesaccountname
      salesaccountid
      __typename
    }

    createInvoiceLineNonGST(createInvoiceLineNonGSTInput: $createInvoiceLineNonGSTInput) {
      invoiceid
      invoiceitemid
      companyid
      companybranchid
      enteredtimestamp
      expiredtimestamp
      gstrate
      gsttypecd
      gstamount
      cessamount
      lastupdatedby
      statuscode
      statusmessage
      __typename
    }

    createInvoiceLineNonItems(createInvoiceLineNonItemsInput: $createInvoiceLineNonItemsInput) {
      invoiceid
      invoiceitemid
      companyid
      companybranchid
      enteredtimestamp
      expiredtimestamp
      invoicelineitemtype
      incomeaccountid
      hsnsaccode
      taxability
      itemdescription
      taxableamount
      netamount
      relatedaccounts {
        accountsid
        companyid
        accountname
        relatedaccountgstdetails {
          accountid
          companyid
          effectivedate
          expireddate
          gstrate
          __typename
        }
        relatedaccountopeningbalance {
          financialyearid
          startdate
          creditamount
          debitamount
          __typename
        }
      }
      lastupdatedby
      statuscode
      statusmessage
      hsnsacid
      hsncodetype
      gstrate
      incomeaccountname
      __typename
    }

    createInvoiceTCSDetails(createInvoiceTCSDetailsInput: $createInvoiceTCSDetailsInput) {
      invoiceid
      companyid
      tcsapplicablecd
      totaltaxableamount
      tcsamount
      lastupdatedby
      statuscode
      statusmessage
      tcspercentage
      __typename
    }

    createPartyAddressEntity(createPartyAddressEntityInput: $createPartyAddressEntityInput) {
      id
      objecttype
      line1
      city
      statecode
      statuscode
      pincode
      lastupdatedby
      __typename
    }
      createTransactionWithSpecificTimev2(
      createTransactionWithSpecificTimeInput: $createTransactionWithSpecificTimeInput
    ) {
      transactionid
      companyid
      statuscode
      statusmessage
      __typename
    }
  }
`;


export const createInvoiceBatchWithoutImages = /* GraphQL */ `
  mutation CreateInvoiceBatch(
    $createInvoiceMasterInput: CreateInvoiceMasterInput!
    $createInvoiceDispatchInput: [CreateInvoiceDispatchInput!]!
    $createInvoiceLineGSTInput: [CreateInvoiceLineGSTInput!]!
    $createInvoiceLineItemsInput: [CreateInvoiceLineItemsInput!]!
    $createInvoiceLineNonGSTInput: [CreateInvoiceLineNonGSTInput!]!
    $createInvoiceLineNonItemsInput: [CreateInvoiceLineNonItemsInput!]!
    $createInvoiceTCSDetailsInput: [CreateInvoiceTCSDetailsInput!]!
    $createPartyAddressEntityInput: [CreatePartyAddressEntityInput!]!
    $createTransactionWithSpecificTimeInput: CreateTransactionWithSpecificTimeInput!
    

  ) {
    createInvoiceMaster(createInvoiceMasterInput: $createInvoiceMasterInput) {
      invoiceid
      companyid
      invoicenumber
      lastupdatedby
      statuscode
      statusmessage
      cancelflag
    }

    createInvoiceDispatch(createInvoiceDispatchInput: $createInvoiceDispatchInput) {
      invoiceid
      dispatchid
      companyid
      companybranchid
      enteredtimestamp
      expiredtimestamp
      transportationcd
      vehiclenumber
      dispatchdate
      ewaybillnumber
      lastupdatedby
      statuscode
      statusmessage
      __typename
    }

    createInvoiceLineGST(createInvoiceLineGSTInput: $createInvoiceLineGSTInput) {
      invoiceid
      invoiceitemid
      companyid
      companybranchid
      enteredtimestamp
      expiredtimestamp
      gstrate
      gsttypecd
      gstamount
      cessamount
      lastupdatedby
      statuscode
      statusmessage
      __typename
    }

    createInvoiceLineItems(createInvoiceLineItemsInput: $createInvoiceLineItemsInput) {
      invoiceid
      invoiceitemid
      companyid
      companybranchid
      enteredtimestamp
      expiredtimestamp
      lineitemnumber
      invoicelineitemtype
      itemid
      quantity
      unittypecd
      itemrate
      itemamount
      itemdiscount
      netamount
      hsnsaccode
      taxability
      itemname
      relatedinvoicelinegst {
        invoiceid
        invoiceitemid
        companyid
        companybranchid
        enteredtimestamp
        expiredtimestamp
        gstrate
        gsttypecd
        gstamount
        cessamount
        lastupdatedby
        statuscode
        statusmessage
        __typename
      }
      relateditemmaster {
        itemid
        itemcode
        companyid
        enteredtimestamp
        expiredtimestamp
        itemname
        salesinvoiceflag
        purchaseinvoiceflag
        itemcategorycd
        measurementcd
        currencycd
        salesaccountid
        purchaseaccountid
        taxabilitycd
        reversechargeflag
        itemtype
        hsnid
        is_active
        statuscode
        statusmessage
        relateditemamountdetails {
          id
          itemid
          companyid
          companybranchid
          enteredtimestamp
          expiredtimestamp
          amount
          effectivedate
          expireddate
          hsnid
          gstcompensationtype
          gstcompensationvalue
          gstrate
          statuscode
          statusmessage
          lastupdatedby
          discounttype
          discountvalue
          invoicetype
          pricetype
           pricetypeid
          isactive
          isdefault
          __typename
        }
      }
      lastupdatedby
      statuscode
      statusmessage
      pricetype
      lotid
      hsnsacid
      hsncodetype
      hsncodevalue
      hsndescription
      gstrate
      gsttypecd
      gstamount
      cessamount
      unit
      uqc
      salesaccountname
      salesaccountid
      __typename
    }

    createInvoiceLineNonGST(createInvoiceLineNonGSTInput: $createInvoiceLineNonGSTInput) {
      invoiceid
      invoiceitemid
      companyid
      companybranchid
      enteredtimestamp
      expiredtimestamp
      gstrate
      gsttypecd
      gstamount
      cessamount
      lastupdatedby
      statuscode
      statusmessage
      __typename
    }

    createInvoiceLineNonItems(createInvoiceLineNonItemsInput: $createInvoiceLineNonItemsInput) {
      invoiceid
      invoiceitemid
      companyid
      companybranchid
      enteredtimestamp
      expiredtimestamp
      invoicelineitemtype
      incomeaccountid
      hsnsaccode
      taxability
      itemdescription
      taxableamount
      netamount
      relatedaccounts {
        accountsid
        companyid
        accountname
        relatedaccountgstdetails {
          accountid
          companyid
          effectivedate
          expireddate
          gstrate
          __typename
        }
        relatedaccountopeningbalance {
          financialyearid
          startdate
          creditamount
          debitamount
          __typename
        }
      }
      lastupdatedby
      statuscode
      statusmessage
      hsnsacid
      hsncodetype
      gstrate
      incomeaccountname
      __typename
    }

    createInvoiceTCSDetails(createInvoiceTCSDetailsInput: $createInvoiceTCSDetailsInput) {
      invoiceid
      companyid
      tcsapplicablecd
      totaltaxableamount
      tcsamount
      lastupdatedby
      statuscode
      statusmessage
      tcspercentage
      __typename
    }

    createPartyAddressEntity(createPartyAddressEntityInput: $createPartyAddressEntityInput) {
      id
      objecttype
      line1
      city
      statecode
      statuscode
      pincode
      lastupdatedby
      __typename
    }
   createTransactionWithSpecificTimev2(
      createTransactionWithSpecificTimeInput: $createTransactionWithSpecificTimeInput
    ) {
      transactionid
      companyid
      statuscode
      statusmessage
      __typename
    }
  }
`;
export const createPurchaseBatch = /* GraphQL */ `
  mutation createPurchaseBatch(
    $createPurchaseMasterInput: CreatePurchaseMasterInput!
    $createPurchaseAttachmentInput: [CreatePurchaseAttachmentInput!]!
    $createPurchaseLineItemsInput: [CreatePurchaseLineItemsInput!]!
    $createPurchaseLineNonItemsInput: [CreatePurchaseLineNonItemsInput!]!
    $createPurchaseLineNonGSTInput: [CreatePurchaseLineNonGSTInput!]!
    $createPurchaseLineGSTInput: [CreatePurchaseLineGSTInput!]!
    $createPurchaseTDSDetailsInput: [CreatePurchaseTDSDetailsInput!]!
    $createPurchaseTCSDetailsInput: [CreatePurchaseTCSDetailsInput!]!
    $createPartyAddressEntityInput: [CreatePartyAddressEntityInput]!
     $createTransactionWithSpecificTimeInput: CreateTransactionWithSpecificTimeInput!
    
  ) {
    createPurchaseMaster(
      createPurchaseMasterInput: $createPurchaseMasterInput
    ) {
      purchaseid
      companyid
      companybranchid
      enteredtimestamp
      expiredtimestamp
      statuscode
      statusmessage
    }
    createPurchaseAttachment(
      createPurchaseAttachmentInput: $createPurchaseAttachmentInput
    ) {
      purchaseid
      attachmentid
      companyid
      statuscode
      statusmessage
      type
    }
    createPurchaseLineItems(
      createPurchaseLineItemsInput: $createPurchaseLineItemsInput
    ) {
      purchaseid
      purchaseitemid
      companyid
      statuscode
      statusmessage
    }
    createPurchaseLineNonItems(
      createPurchaseLineNonItemsInput: $createPurchaseLineNonItemsInput
    ) {
      purchaseid
      purchaseitemid
      companyid
      statuscode
      statusmessage
    }
    createPurchaseLineNonGST(
      createPurchaseLineNonGSTInput: $createPurchaseLineNonGSTInput
    ) {
      purchaseid
      purchaseitemid
      companyid
      statuscode
      statusmessage
    }
    createPurchaseLineGST(
      createPurchaseLineGSTInput: $createPurchaseLineGSTInput
    ) {
      purchaseid
      purchaseitemid
      companyid
      statuscode
      statusmessage
    }
    createPurchaseTDSDetails(
      createPurchaseTDSDetailsInput: $createPurchaseTDSDetailsInput
    ) {
      purchaseid
      companyid
      statuscode
      statusmessage
    }
    createPurchaseTCSDetails(
      createPurchaseTCSDetailsInput: $createPurchaseTCSDetailsInput
    ) {
      purchaseid
      companyid
      companybranchid
      statuscode
      statusmessage
    }
    createPartyAddressEntity(
      createPartyAddressEntityInput: $createPartyAddressEntityInput
    ) {
      id
      objecttype
      objectid
      statuscode
      statusmessage
    }
   createTransactionWithSpecificTimev2(
      createTransactionWithSpecificTimeInput: $createTransactionWithSpecificTimeInput
    ) {
      transactionid
      companyid
      statuscode
      statusmessage
      __typename
    }
  }
`;
export const createPurchaseBatchWithoutImages = /* GraphQL */ `
  mutation createPurchaseBatchWithoutImages(
    $createPurchaseMasterInput: CreatePurchaseMasterInput!
    $createPurchaseLineItemsInput: [CreatePurchaseLineItemsInput!]!
    $createPurchaseLineNonItemsInput: [CreatePurchaseLineNonItemsInput!]!
    $createPurchaseLineNonGSTInput: [CreatePurchaseLineNonGSTInput!]!
    $createPurchaseLineGSTInput: [CreatePurchaseLineGSTInput!]!
    $createPurchaseTDSDetailsInput: [CreatePurchaseTDSDetailsInput!]!
    $createPurchaseTCSDetailsInput: [CreatePurchaseTCSDetailsInput!]!
    $createPartyAddressEntityInput: [CreatePartyAddressEntityInput]!
    $createTransactionWithSpecificTimeInput: CreateTransactionWithSpecificTimeInput!
  ) {
    createPurchaseMaster(
      createPurchaseMasterInput: $createPurchaseMasterInput
    ) {
      purchaseid
      companyid
      companybranchid
      enteredtimestamp
      expiredtimestamp
      statuscode
      statusmessage
    }

    createPurchaseLineItems(
      createPurchaseLineItemsInput: $createPurchaseLineItemsInput
    ) {
      purchaseid
      purchaseitemid
      companyid
      statuscode
      statusmessage
    }
    createPurchaseLineNonItems(
      createPurchaseLineNonItemsInput: $createPurchaseLineNonItemsInput
    ) {
      purchaseid
      purchaseitemid
      companyid
      statuscode
      statusmessage
    }
    createPurchaseLineNonGST(
      createPurchaseLineNonGSTInput: $createPurchaseLineNonGSTInput
    ) {
      purchaseid
      purchaseitemid
      companyid
      statuscode
      statusmessage
    }
    createPurchaseLineGST(
      createPurchaseLineGSTInput: $createPurchaseLineGSTInput
    ) {
      purchaseid
      purchaseitemid
      companyid
      statuscode
      statusmessage
    }
    createPurchaseTDSDetails(
      createPurchaseTDSDetailsInput: $createPurchaseTDSDetailsInput
    ) {
      purchaseid
      companyid
      statuscode
      statusmessage
    }
    createPurchaseTCSDetails(
      createPurchaseTCSDetailsInput: $createPurchaseTCSDetailsInput
    ) {
      purchaseid
      companyid
      companybranchid
      statuscode
      statusmessage
    }
    createPartyAddressEntity(
      createPartyAddressEntityInput: $createPartyAddressEntityInput
    ) {
      id
      objecttype
      objectid
      statuscode
      statusmessage
    }
   createTransactionWithSpecificTimev2(
      createTransactionWithSpecificTimeInput: $createTransactionWithSpecificTimeInput
    ) {
      transactionid
      companyid
      statuscode
      statusmessage
      __typename
    }
  }
`;




export const deleteInvoiceMasterTrasaction =`    
mutation deleteInvoiceMasterTrasaction(
  $createInvoiceMasterInput: CreateInvoiceMasterInput
  $transactionId1: Int
  $transactionId2: Int
) {
  createInvoiceMaster(createInvoiceMasterInput: $createInvoiceMasterInput) {
    invoiceid
    companyid
    statuscode
    statusmessage
  }
  deleteTransactionMaster(transactionid: $transactionId1) {
    transactionid
    companyid
    statuscode
    statusmessage
  }
  deleteInvTransactionMaster: deleteTransactionMaster(transactionid: $transactionId2) {
    transactionid
    companyid
    statuscode
    statusmessage
  }
}`;
export const deleteInvoiceMaster =`    
mutation deleteInvoiceMaster(
  $createInvoiceMasterInput: CreateInvoiceMasterInput
  $transactionId2: Int
  
) {
  createInvoiceMaster(createInvoiceMasterInput: $createInvoiceMasterInput) {
    invoiceid
    companyid
    statuscode
    statusmessage
  }
  
  deleteInvTransactionMaster: deleteTransactionMaster(transactionid: $transactionId2) {
    transactionid
    companyid
    statuscode
    statusmessage
  }
}`;
export const CreateCrDrBatch = /* GraphQL */ `
mutation CreateCrDrBatch(
  $createCrDrNoteMasterInput: CreateCrDrNoteMasterInput!
  $createCrDrNoteDetailsInput: [CreateCrDrNoteDetailsInput!]!
  $createCrDrNoteLineItemsInput: [CreateCrDrNoteLineItemsInput!]!
  $createCrDrNoteLineNonItemsInput: [CreateCrDrNoteLineNonItemsInput!]!
  $createCrDrNoteTDSDetailsInput: [CreateCrDrNoteTDSDetailsInput!]!
  $createCrDrNoteTCSDetailsInput: [CreateCrDrNoteTCSDetailsInput!]!
  $createCrDrNoteDispatchInput: [CreateCrDrNoteDispatchInput!]!
  $createPartyAddressEntityInput: [CreatePartyAddressEntityInput]!
  $createTransactionWithSpecificTimeInput: CreateTransactionWithSpecificTimeInput!
  $createCrDrAttachmentInput: [CreateCrDrAttachmentInput!]!
) {
  createCrDrNoteMaster(createCrDrNoteMasterInput: $createCrDrNoteMasterInput) {
    crdrnoteid
    companyid
    statuscode
    statusmessage
  }
  createCrDrNoteDetails(createCrDrNoteDetailsInput: $createCrDrNoteDetailsInput) {
    crdrnoteid
    companyid
    statuscode
    statusmessage
  }
  createCrDrNoteLineItems(createCrDrNoteLineItemsInput: $createCrDrNoteLineItemsInput) {
    crdrnoteid
    crdrnoteitemid
    statuscode
    statusmessage
  }
  createCrDrNoteLineNonItems(createCrDrNoteLineNonItemsInput: $createCrDrNoteLineNonItemsInput) {
    crdrnoteid
    crdrnoteitemid
    statuscode
    statusmessage
  }
  createCrDrNoteTDSDetails(createCrDrNoteTDSDetailsInput: $createCrDrNoteTDSDetailsInput) {
    crdrnoteid
    companyid
    statuscode
    statusmessage
  }
  createCrDrNoteTCSDetails(createCrDrNoteTCSDetailsInput: $createCrDrNoteTCSDetailsInput) {
    crdrnoteid
    companyid
    statuscode
    statusmessage
  }
  createCrDrNoteDispatch(createCrDrNoteDispatchInput: $createCrDrNoteDispatchInput) {
    crdrnoteid
    dispatchid
    companyid
    statuscode
    statusmessage
  }
  createPartyAddressEntity(createPartyAddressEntityInput: $createPartyAddressEntityInput) {
    id
    objecttype
    objectid
    statuscode
    statusmessage
  }
  createTransactionWithSpecificTimev2(
      createTransactionWithSpecificTimeInput: $createTransactionWithSpecificTimeInput
    ) {
      transactionid
      companyid
      statuscode
      statusmessage
      __typename
    }
  createCrDrAttachment(createCrDrAttachmentInput: $createCrDrAttachmentInput) {
    crdrnoteid
    attachmentid
    companyid
    statuscode
    statusmessage
  }
}`
;

export const createPosBatch = /* GraphQL */ `
  mutation CreatePosBatch(
    $createInvoiceMasterInput: CreateInvoiceMasterInput!
    $createInvoiceAttachmentInput: [CreateInvoiceAttachmentInput!]!
    $createInvoiceLineGSTInput: [CreateInvoiceLineGSTInput!]!
    $createInvoiceLineItemsInput: [CreateInvoiceLineItemsInput!]!
    $createInvoiceTCSDetailsInput: [CreateInvoiceTCSDetailsInput!]!
    $createTransactionWithSpecificTimeInput: CreateTransactionWithSpecificTimeInput!
  ) {
    createInvoiceMaster(createInvoiceMasterInput: $createInvoiceMasterInput) {
      invoiceid
      companyid
      invoicenumber
      lastupdatedby
      statuscode
      statusmessage
      cancelflag
    }

    createInvoiceAttachment(createInvoiceAttachmentInput: $createInvoiceAttachmentInput) {
      invoiceid
      attachmentid
      companyid
      companybranchid
      enteredtimestamp
      expiredtimestamp
      attachmentname
      attachmenturl
      lastupdatedby
      statuscode
      statusmessage
      documentname
      type
      __typename
    }

    createInvoiceLineGST(createInvoiceLineGSTInput: $createInvoiceLineGSTInput) {
      invoiceid
      invoiceitemid
      companyid
      companybranchid
      enteredtimestamp
      expiredtimestamp
      gstrate
      gsttypecd
      gstamount
      cessamount
      lastupdatedby
      statuscode
      statusmessage
      __typename
    }

    createInvoiceLineItems(createInvoiceLineItemsInput: $createInvoiceLineItemsInput) {
      invoiceid
      invoiceitemid
      companyid
      companybranchid
      enteredtimestamp
      expiredtimestamp
      lineitemnumber
      invoicelineitemtype
      itemid
      quantity
      unittypecd
      itemrate
      itemamount
      itemdiscount
      netamount
      hsnsaccode
      taxability
      relatedinvoicelinegst {
        invoiceid
        invoiceitemid
        companyid
        companybranchid
        enteredtimestamp
        expiredtimestamp
        gstrate
        gsttypecd
        gstamount
        cessamount
        lastupdatedby
        statuscode
        statusmessage
        __typename
      }
      relateditemmaster {
        itemid
        itemcode
        companyid
        enteredtimestamp
        expiredtimestamp
        itemname
        salesinvoiceflag
        purchaseinvoiceflag
        itemcategorycd
        measurementcd
        currencycd
        salesaccountid
        purchaseaccountid
        taxabilitycd
        reversechargeflag
        itemtype
        hsnid
        is_active
        statuscode
        statusmessage
        relateditemamountdetails {
          id
          itemid
          companyid
          companybranchid
          enteredtimestamp
          expiredtimestamp
          amount
          effectivedate
          expireddate
          hsnid
          gstcompensationtype
          gstcompensationvalue
          gstrate
          statuscode
          statusmessage
          lastupdatedby
          discounttype
          discountvalue
          invoicetype
          pricetype
          isactive
          isdefault
          __typename
        }
      }
      lastupdatedby
      statuscode
      statusmessage
      pricetype
      lotid
      hsnsacid
      hsncodetype
      hsncodevalue
      hsndescription
      gstrate
      gsttypecd
      gstamount
      cessamount
      unit
      uqc
      salesaccountname
      salesaccountid
      __typename
    }

    createInvoiceTCSDetails(createInvoiceTCSDetailsInput: $createInvoiceTCSDetailsInput) {
      invoiceid
      companyid
      tcsapplicablecd
      totaltaxableamount
      tcsamount
      lastupdatedby
      statuscode
      statusmessage
      tcspercentage
      __typename
    }

    createTransactionWithSpecificTimev2(
      createTransactionWithSpecificTimeInput: $createTransactionWithSpecificTimeInput
    ) {
      transactionid
      companyid
      statuscode
      statusmessage
      __typename
    }
  }
`;


export const deleteCrDrBatch = /* GraphQL */ `
  mutation deleteCrDrBatch(
    $createCrDrNoteMasterInput: CreateCrDrNoteMasterInput!
  ) {
    createCrDrNoteMaster(
      createCrDrNoteMasterInput: $createCrDrNoteMasterInput
    ) {
      crdrnoteid
      companyid
}
}`;





